// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"map-unlocked"},"children":[{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M14.499 17H21.499V21.5H14.499V17Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M15 6.5L9 3L3 6.5V20L9 17.5M15 6.5L21 4V10M15 6.5V10M9 17.5V3.5M9 17.5L10.5 18.375","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M15.75 17V15.25C15.75 14.0074 16.7574 13 18 13C18.6188 13 19.1793 13.2498 19.5861 13.6541M14.499 17H21.499V21.5H14.499V17Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const MapUnlockedIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'map-unlocked',
    ref,
    icon: element,
  },
));

MapUnlockedIcon.displayName = 'MapUnlockedIcon';

export default MapUnlockedIcon;
